<template>
  <div class="d-flex flex-column container align-center">
    <div class="text-center reason">
      <h1 data-aos="slide-left" data-aos-duration="10000">

      </h1>
      <p data-aos="slide-right" data-aos-duration="10000">
          Adquiere Nuevas destrezas
      </p>
    </div>
    <div
      class="d-flex flex-wrap align-center justify-center"
      data-aos="slide-up"
      data-aos-duration="10000"
    >
      <ReasonCardComponent class="align-center text-center">
        <div class="slot-image-background pink " slot="image">
          <img src="../../assets/images/web-design.png" />
        </div>
        <h3 slot="heading">Aprende desde tu idioma natal</h3>
      </ReasonCardComponent>
      <ReasonCardComponent class="align-center text-center">
        <div class="slot-image-background light-blue" slot="image">
          <img src="../../assets/images/trophy.png" />
        </div>
        <h3 slot="heading">Enfrenta nuevos desafios</h3>
      </ReasonCardComponent>
      <ReasonCardComponent class="align-center text-center">
        <div class="slot-image-background light-yellow" slot="image">
          <img src="../../assets/images/computer.png" />
        </div>
        <h3 slot="heading">Ingresa al magico mundo de la programacion</h3>
      </ReasonCardComponent>
      <ReasonCardComponent class="align-center text-center">
        <div class="slot-image-background light-green" slot="image">
          <img src="../../assets/images/customer-support.png" />
        </div>
        <h3 slot="heading">Genera nuevas soluciones </h3>
      </ReasonCardComponent>
      <ReasonCardComponent class="align-center text-center">
        <div class="slot-image-background light-purple" slot="image">
          <img src="../../assets/images/ui-image.png" />
        </div>
        <h3 slot="heading">Capacitate</h3>
      </ReasonCardComponent>
      <ReasonCardComponent class="align-center text-center">
        <div class="slot-image-background light-blue" slot="image">
          <img src="../../assets/images/customer-service.png" />
        </div>
        <h3 slot="heading">Monitorea tus Resultados</h3>

      </ReasonCardComponent>
    </div>
  </div>
</template>
<script>
import ReasonCardComponent from "./ReasonCardComponent";
export default {
  components: {
    ReasonCardComponent
  }
};
</script>
